import { Model } from 'pinia-orm';

export default class Country extends Model {

    static get entity() {
        return 'countries'
    }

    static fields() {
        return {
            id: this.uid(),
            name: this.attr(''),
            code: this.attr(''),
        }
    }
}
